<template>
	<v-card flat>
		<v-data-table :headers="dTable.headers" :items="dPriAlumnosBecados" :loading="dTable.loading" class="elevation-1">
            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
            <template v-slot:top>
                <v-toolbar flat style="background-color:#455A64" dark>
                    <v-toolbar-title>BECAS</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical ></v-divider>
                    <v-dialog v-model="dModal.dialog" persistent max-width="700px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" class="mx-4" v-bind="attrs" v-on="on"><v-icon>add</v-icon> Agregar</v-btn>
                        </template>
                        <v-card>
                            <v-card-title :class="dModal.editedIndex === -1 ? 'blue' : 'amber'">
                                <span class="headline">{{dModal.editedIndex === -1 ? 'Agregar' : 'Editar'}}</span>
                                <v-spacer></v-spacer>
                                <v-btn :color="dModal.editedIndex === -1 ? 'primary' : 'warning'" @click="fuModalSave" :loading="dModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                                <v-btn @click="fuModalClose" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text class="p-0 pt-3">
                                <v-form ref="refModal">
                                    <v-row dense>
                                        <v-col cols="12" xm="12" sm="6" md="6">
                                            <v-select v-model="dPriAlumnosBecado.IdTipoBeca" label="* Tipo"
                                                    :items=dPriAlumnosBecadoTipos item-value="IdTipoBeca" item-text="TipoBeca"
                                                    :disabled="dIsUpdating" filled prepend-inner-icon="label" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                        </v-col>
                                        <v-col cols="12" xm="12" sm="6" md="6">
                                            <v-text-field v-model="dPriAlumnosBecado.DocumentoAprobacion" label="* Documento Aprobacion" filled prepend-inner-icon="assignment_turned_in" :rules="[v => !!v || 'El campo es requerido']" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="12" sm="6" md="6">
                                            <v-menu
                                                v-model="dFInicioMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="dFechaInicio"
                                                        label="* Fecha Inicio"
                                                        prepend-inner-icon="event_note"
                                                        readonly
                                                        filled
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dFechaInicio"
                                                    @input="dFInicioMenu = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" xm="12" sm="6" md="6">
                                            <v-menu
                                                v-model="dFFinMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="dFechaFinalizacion"
                                                        label="* Fecha Fin"
                                                        prepend-inner-icon="event_note"
                                                        readonly
                                                        filled
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dFechaFinalizacion"
                                                    @input="dFFinMenu = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col v-if="dModal.editedIndex !== -1" cols="12" xm="12" sm="6" md="6">
                                            <v-select v-model="dPriAlumnosBecado.activo" label="* Estado"
                                                :items="[{text: 'ACTIVADO', value: 1},
                                                        {text: 'DESACTIVADO', value: 0}]"
                                                prepend-inner-icon="invert_colors" filled>
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="fuModalEdit(item)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="fuFinalizar(item)" color="blue-grey" block><v-icon>remove_circle</v-icon> Desactivar</v-btn></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:[`item.FechaInicio`]="{ item }">
                <span>{{item.FechaInicio.substr(0, 10)}}</span>
            </template>
            <template v-slot:[`item.FechaFinalizacion`]="{ item }">
                <span>{{item.FechaFinalizacion.substr(0, 10)}}</span>
            </template>
            <template v-slot:[`item.activo`]="{ item }">
                <v-icon v-if="item.activo=='1'" color="success" title="ACTIVADO">check_circle</v-icon>
                <v-icon v-else color="blue-grey" title="DESACTIVADO">remove_circle</v-icon>
            </template>
        </v-data-table>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
	</v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'CPriAlumnosBecado',
    props: ['pIdAlumno'],
    mounted(){
        this.fuLoad();
        if(this.ssUser) this.dPriAlumnosBecado.usuarioRegistro=this.dPriAlumnosBecadoDefault.usuarioRegistro=this.ssUser.Usuario;

        this.dPriAlumnosBecado.IdAlumno = this.dPriAlumnosBecadoDefault.IdAlumno = this.pIdAlumno;
    },
    data: () => ({
        dFInicioMenu: false,
        dFechaInicio: '',
        dFFinMenu: false,
        dFechaFinalizacion: '',
    	dIsUpdating: false,
        dPriAlumnosBecado:{
            IdAlumno: '',
            IdTipoBeca: '',
            FechaInicio: '',
            FechaFinalizacion: '',
            DocumentoAprobacion: '',
            activo: 1,
            usuarioRegistro: '',
        },
        dPriAlumnosBecadoDefault:{
            IdAlumno: '',
            IdTipoBeca: '',
            FechaInicio: '',
            FechaFinalizacion: '',
            DocumentoAprobacion: '',
            activo: 1,
            usuarioRegistro: '',
        },
        dPriAlumnosBecados: [],
    	dPriAlumnosBecadoItem: null,
        dPriAlumnosBecadoTipos: [],
    	dModal: {
            dialog: false,
            editedIndex: -1,
            IsUpdating: false,
        },
        dSnackbar: false,
    	dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'IdAlumnoBecado', text: 'IdAlumnoBecado', align: ' d-none'},
                {value: 'IdTipoBeca', text: 'IdTipoBeca', align: ' d-none'},
                {value: 'prialumnosbecadotipo.TipoBeca', text: 'Tipo'},
                {value: 'FechaInicio', text: 'F. Inicio'},
                {value: 'FechaFinalizacion', text: 'F. Finalizacion'},
                {value: 'DocumentoAprobacion', text: 'Documento Aprobacion'},
                {value: 'activo', text: 'Estado'}
            ],
            loading: false,
        }
    }),
    methods: {
    	async fuLoad(){
            this.dTable.loading = true;
            this.dPriAlumnosBecados = [];
            this.dPriAlumnosBecadoTipos = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query load($IdAlumno: ID!){
                        prialumnosbecadoByIdAlumno(IdAlumno:$IdAlumno){
                            IdAlumnoBecado
                            FechaInicio
                            FechaFinalizacion
                            DocumentoAprobacion
                            activo
                            IdTipoBeca
                            prialumnosbecadotipo{
                                TipoBeca
                            }
                        }
                        prialumnosbecadotipoByactivo(activo:1){
                            IdTipoBeca
                            TipoBeca
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: this.pIdAlumno
                    }
                })
                this.dPriAlumnosBecados = response.data.prialumnosbecadoByIdAlumno;
                this.dPriAlumnosBecadoTipos = response.data.prialumnosbecadotipoByactivo;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
                this.dTable.loading = false
            }
        },
        fuModalEdit (item) {            
            this.dModal.editedIndex = this.dPriAlumnosBecados.indexOf(item);
            this.dPriAlumnosBecadoItem = Object.assign({}, item);
            this.dPriAlumnosBecado.IdTipoBeca = item.IdTipoBeca.toString();
            this.dPriAlumnosBecado.FechaInicio = item.FechaInicio;
            this.dFechaInicio = item.FechaInicio.substr(0, 10);
            this.dPriAlumnosBecado.FechaFinalizacion = item.FechaFinalizacion;
            this.dFechaFinalizacion = item.FechaFinalizacion.substr(0, 10);
            this.dPriAlumnosBecado.DocumentoAprobacion = item.DocumentoAprobacion;
            this.dPriAlumnosBecado.activo = item.activo;

            this.dModal.dialog = true;
        },
    	fuModalClose(){
            this.dModal.dialog = false
            this.$nextTick(() => {
                this.dPriAlumnosBecado = Object.assign({}, this.dPriAlumnosBecadoDefault);
                this.dModal.editedIndex = -1;
            })
        },
        async fuFinalizar (item) {
            let index = this.dPriAlumnosBecados.indexOf(item);
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnosbecadoUpdate($IdAlumnoBecado: ID!){
                        prialumnosbecadoUpdate(IdAlumnoBecado: $IdAlumnoBecado, input: {
                            activo:0
                        }){
                            IdAlumnoBecado
                        }
                    }`,
                    variables: {
                        IdAlumnoBecado: item.IdAlumnoBecado
                    }
                });
                if(response.data){
                    this.dPriAlumnosBecados[index].activo=0;
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó.', 'error')
            } finally {
                this.dTable.loading = false;
            }
        },
        fuFinalizarAgregar(item) {
            this.fuFinalizar(item);
            this.dModal.dialog = true;
        },
        fuModalSave(){
            if(!this.$refs.refModal.validate()){
                this.dSnackbar = true;
            } else {
                if (this.dModal.editedIndex === -1)
                    this.fuCreate();
                else
                    this.fuUpdate();
            }
        },
        async fuCreate () {
            try {
                this.dModal.IsUpdating = true;
                this.dPriAlumnosBecado.FechaInicio = this.dFechaInicio.split("-").join("");
                this.dPriAlumnosBecado.FechaFinalizacion = this.dFechaFinalizacion.split("-").join("");

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnosbecadoCreate($input: prialumnosbecadoCreateInput!){
                        prialumnosbecadoCreate(input: $input){
                            IdAlumnoBecado
                            prialumnosbecadotipo{
                                TipoBeca
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        input: this.dPriAlumnosBecado
                    }
                });
                if(response.data){
                    this.fuLoad();
                    Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dModal.IsUpdating = false;
                this.fuModalClose();
            }
        },
        async fuUpdate () {
            try {
                this.dModal.IsUpdating = true;
                this.dPriAlumnosBecado.FechaInicio = this.dFechaInicio.split("-").join("");
                this.dPriAlumnosBecado.FechaFinalizacion = this.dFechaFinalizacion.split("-").join("");

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnosbecadoUpdate($IdAlumnoBecado: ID!, $input: prialumnosbecadoUpdateInput!){
                        prialumnosbecadoUpdate(IdAlumnoBecado: $IdAlumnoBecado, input: $input){
                            IdAlumnoBecado
                            prialumnosbecadotipo{
                                TipoBeca
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumnoBecado: this.dPriAlumnosBecadoItem.IdAlumnoBecado,
                        input: this.dPriAlumnosBecado
                    }
                });
                if(response.data){
                    this.fuLoad();
                    Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dModal.IsUpdating = false;
                this.fuModalClose();
            }
        }
    },
    computed: {
        ...mapState(['ssUser'])
    },
}
</script>
